
const baseGeneralUrl = "General"

  const endpoints = {
    getPageByPageTypeId:`${baseGeneralUrl}/GetPageByPageTypeId`,
   
  };
  
  export default endpoints;